module.exports = __webpack_public_path__ + "img/banner-primeblocks.d1cbeffb.png";